import { notification } from 'antd'
import { useQuery } from 'react-query'

import { QUERY_KEYS } from '@api'
import { SupplierFilters } from '@types'

import { SuppliersApi } from './api'

const onError = () => {
  notification.error({
    message: 'Error al obtener los suppliers',
  })
}

const useSuppliers = (filters?: SupplierFilters) => {
  const { data, isLoading } = useQuery([QUERY_KEYS.SUPPLIERS], SuppliersApi.getSuppliers, {
    staleTime: 60000,
    onError,
  })
  const { data: suppliersByMgmt } = useQuery(
    ['suppliersByMgmt', { filters }],
    () => SuppliersApi.getSuppliersByMgmt({ filters }),
    {
      staleTime: 60000,
      onError,
    },
  )
  const suppliersDepots = data?.map(supplier => supplier.depots)
  const depots = suppliersDepots
    ?.filter(mappedDepots => {
      if (mappedDepots.length > 0) {
        return true
      }
      return false
    })
    .map(filteredDepots => filteredDepots)
  const uniqueSupZones = [...new Set(data?.filter(s => s.zone).map(s => s.zone))]

  const suppliersZones = uniqueSupZones?.map(zone => ({
    label: zone,
    value: zone,
  }))

  const suppliersOptions = data
    ?.map(supplier => ({
      label: supplier.businessName,
      value: supplier.id,
    }))
    .sort((a, b) => (a.label.toUpperCase() < b.label.toUpperCase() ? -1 : 1))
  const suppliersByMgmtOptions = suppliersByMgmt?.map(supplier => ({
    label: supplier.businessName,
    value: supplier.id,
  }))

  return {
    suppliers: data,
    isLoading,
    suppliersOptions,
    suppliersZones,
    suppliersByMgmtOptions,
    depots,
  }
}
const useSuppliersZones = () => {
  const { data, isLoading } = useQuery([QUERY_KEYS.SUPPLIERS], SuppliersApi.getSuppliers, {
    staleTime: 60000,
    onError,
  })
  const uniqueZones = [
    ...new Set(
      data
        ?.filter(c => c.zone)
        .sort((a, b) => (a.zone.toUpperCase() < b.zone.toUpperCase() ? -1 : 1))
        .map(c => c.zone),
    ),
  ]
  const suppliersZones = uniqueZones?.map(supplier => ({
    label: supplier,
    value: supplier,
  }))
  return {
    suppliers: data,
    isLoading,
    suppliersZones,
  }
}
export { useSuppliers, useSuppliersZones }
